import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFilter } from "@result/rui/utils/api";

import ApiClient from "#/redux/api/ApiClient";

const baseUrl = "/api/sif/drob/semeCelice";

export const getSeedCellTypes = createAsyncThunk(
  "seed-cells/getAll",
  async (_, { rejectWithValue }) => {
    // eslint-disable-next-line no-console
    console.warn("Deprecated, migrate to LookupTable hooks and components");

    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        null,
        { page: 0, size: 1000 },
        new ApiFilter().or((orGroup) => {
          orGroup.where("veljaZaKoze", "EQ", true);
          orGroup.where("veljaZaOvce", "EQ", true);
        })
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const seedCellTypeSlice = createSlice({
  name: "seedCell",
  initialState: {
    list: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSeedCellTypes.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getSeedCellTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload?.content || [];
      })
      .addCase(getSeedCellTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default seedCellTypeSlice.reducer;
